var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-spin",
    {
      attrs: {
        size: "large",
        spinning: _vm.loading,
        wrapperClassName: "global-spin-wrapper",
      },
    },
    [
      _c(
        "div",
        { staticClass: "subscribe-page" },
        [
          _c("a-card", { staticClass: "main-card" }, [
            _c(
              "div",
              { staticStyle: { "margin-bottom": "25px" } },
              [
                _c("Step", {
                  attrs: {
                    current: _vm.$route.query.isfromCamp == 1 ? 2 : 1,
                    isfromCamp: _vm.$route.query.isfromCamp == 1 ? true : false,
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c(
                    "div",
                    { staticClass: "section-title", class: [_vm.lang] },
                    [_vm._v(" " + _vm._s(_vm.$t("AIselection")) + " ")]
                  ),
                  _vm.info.type != 4
                    ? _c(
                        "div",
                        {
                          staticClass: "ant-alert ant-alert-info alertInfo",
                          attrs: { "data-v-564af55a": "", "data-show": "true" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "ant-alert-message",
                              class: [_vm.lang],
                            },
                            [
                              _vm.info.type != 3
                                ? [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("ExplorePrime"))
                                    ),
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "javascript:void(0)" },
                                        on: { click: _vm.showUpgradeModal },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("ExplorePrimeBtn"))
                                        ),
                                      ]
                                    ),
                                  ]
                                : [_vm._v(_vm._s(_vm.$t("PrimePlan")))],
                            ],
                            2
                          ),
                        ]
                      )
                    : _c("div", { staticStyle: { height: "16px" } }),
                  _c(
                    "a-row",
                    { staticClass: "mb24", attrs: { gutter: 16 } },
                    [
                      _c(
                        "a-col",
                        {
                          staticClass: "ai-card-col",
                          attrs: { xs: 24, sm: 12 },
                        },
                        [
                          _c(
                            "a-card",
                            {
                              class: {
                                selected:
                                  _vm.selectedAll || _vm.aiType === "2"
                                    ? true
                                    : false,
                                disabled:
                                  _vm.selectedAll ||
                                  (_vm.info.campType && _vm.info.campType != 2)
                                    ? true
                                    : false,
                              },
                              attrs: { hoverable: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.tapAitypHandle("2")
                                },
                              },
                            },
                            [
                              _c(
                                "a-checkbox",
                                {
                                  class: [_vm.lang],
                                  attrs: {
                                    disabled:
                                      _vm.selectedAll ||
                                      (_vm.info.campType &&
                                        _vm.info.campType != 2)
                                        ? true
                                        : false,
                                    checked:
                                      _vm.selectedAll || _vm.aiType === "2"
                                        ? true
                                        : false,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("AIRecruiter")))]
                              ),
                              _c(
                                "div",
                                { staticClass: "desc", class: [_vm.lang] },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("SmartRecruiter")) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        {
                          staticClass: "ai-card-col",
                          attrs: { xs: 24, sm: 12 },
                        },
                        [
                          _c(
                            "a-card",
                            {
                              class: {
                                selected:
                                  _vm.selectedAll || _vm.aiType === "1"
                                    ? true
                                    : false,
                                disabled:
                                  _vm.selectedAll ||
                                  (_vm.info.campType && _vm.info.campType != 1)
                                    ? true
                                    : false,
                              },
                              attrs: { hoverable: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.tapAitypHandle("1")
                                },
                              },
                            },
                            [
                              _c(
                                "a-checkbox",
                                {
                                  class: [_vm.lang],
                                  attrs: {
                                    disabled:
                                      _vm.selectedAll ||
                                      (_vm.info.campType &&
                                        _vm.info.campType != 1)
                                        ? true
                                        : false,
                                    checked:
                                      _vm.selectedAll || _vm.aiType === "1"
                                        ? true
                                        : false,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("AISslesRep")))]
                              ),
                              _c(
                                "div",
                                { staticClass: "desc", class: [_vm.lang] },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("SmartSales")) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.edit
                    ? _c(
                        "a-form-model",
                        {
                          ref: "form",
                          staticClass: "billing-form",
                          attrs: {
                            model: _vm.form,
                            rules: _vm.rules,
                            "label-col": { span: 24 },
                            "wrapper-col": { span: 24 },
                          },
                        },
                        [
                          _c("div", { staticClass: "section-title" }, [
                            _vm._v(_vm._s(_vm.$t("invoiceInformation"))),
                          ]),
                          _c(
                            "div",
                            { staticClass: "billInfo" },
                            [
                              _c("div", { staticClass: "section-title2" }, [
                                _vm._v(_vm._s(_vm.$t("BillingContact"))),
                              ]),
                              _c(
                                "a-row",
                                { attrs: { gutter: 16 } },
                                [
                                  _c(
                                    "a-col",
                                    { attrs: { xs: 24, sm: 12 } },
                                    [
                                      _c(
                                        "a-form-model-item",
                                        {
                                          key: "5",
                                          attrs: {
                                            label: _vm.$t("UserType"),
                                            prop: "is_personal",
                                            required: "",
                                          },
                                        },
                                        [
                                          _c(
                                            "a-select",
                                            {
                                              attrs: {
                                                placeholder:
                                                  _vm.$t("SelectUserType"),
                                              },
                                              model: {
                                                value: _vm.form.is_personal,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "is_personal",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.is_personal",
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select-option",
                                                {
                                                  key: "1111",
                                                  class: [_vm.lang],
                                                  attrs: { value: "1" },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Soloentrepreneur"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "a-select-option",
                                                {
                                                  key: "1112",
                                                  class: [_vm.lang],
                                                  attrs: { value: "2" },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("ForEnterprises")
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-col",
                                    { attrs: { xs: 24, sm: 12 } },
                                    [
                                      _c(
                                        "a-form-model-item",
                                        {
                                          key: "1",
                                          attrs: {
                                            label: _vm.$t("Firstname"),
                                            prop: "first_name",
                                            required: "",
                                          },
                                        },
                                        [
                                          _c("a-input", {
                                            attrs: {
                                              placeholder: _vm.$t("EnterFirst"),
                                            },
                                            model: {
                                              value: _vm.form.first_name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "first_name",
                                                  $$v
                                                )
                                              },
                                              expression: "form.first_name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-row",
                                { attrs: { gutter: 16 } },
                                [
                                  _c(
                                    "a-col",
                                    { attrs: { xs: 24, sm: 12 } },
                                    [
                                      _c(
                                        "a-form-model-item",
                                        {
                                          key: "2",
                                          attrs: {
                                            label: _vm.$t("lastName"),
                                            prop: "last_name",
                                            required: "",
                                          },
                                        },
                                        [
                                          _c("a-input", {
                                            attrs: {
                                              placeholder:
                                                _vm.$t("EnterLastName"),
                                            },
                                            model: {
                                              value: _vm.form.last_name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "last_name",
                                                  $$v
                                                )
                                              },
                                              expression: "form.last_name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-col",
                                    { attrs: { xs: 24, sm: 12 } },
                                    [
                                      _c(
                                        "a-form-model-item",
                                        {
                                          key: "6",
                                          attrs: {
                                            label: _vm.$t("Email"),
                                            prop: "email",
                                            required: "",
                                          },
                                        },
                                        [
                                          _c("a-input", {
                                            attrs: {
                                              placeholder: _vm.$t("enterEmail"),
                                            },
                                            model: {
                                              value: _vm.form.email,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.form, "email", $$v)
                                              },
                                              expression: "form.email",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.form.is_personal == 1
                                ? _c(
                                    "a-row",
                                    { attrs: { gutter: 16 } },
                                    [
                                      _c(
                                        "a-col",
                                        { attrs: { xs: 24, sm: 12 } },
                                        [
                                          _c(
                                            "a-form-model-item",
                                            {
                                              key: "7",
                                              attrs: {
                                                label: _vm.$t("industry"),
                                                prop: "industry_id",
                                                required: "",
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  attrs: {
                                                    placeholder:
                                                      _vm.$t("selectInstry"),
                                                  },
                                                  model: {
                                                    value: _vm.form.industry_id,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "industry_id",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.industry_id",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.industryList,
                                                  function (item, index) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: index,
                                                        class: [_vm.lang],
                                                        attrs: { value: index },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(item) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.form.industry_id == 15
                                        ? _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "8",
                                                  attrs: {
                                                    label:
                                                      _vm.$t(
                                                        "Enteryourindustry"
                                                      ),
                                                    prop: "industry_desc",
                                                    required: "",
                                                  },
                                                },
                                                [
                                                  _c("a-input", {
                                                    attrs: {
                                                      placeholder: _vm.$t(
                                                        "Pleaseenteryourindustry"
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.industry_desc,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "industry_desc",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.industry_desc",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.form.is_personal == 2
                                ? _c(
                                    "a-row",
                                    { attrs: { gutter: 16 } },
                                    [
                                      _c(
                                        "a-col",
                                        { attrs: { xs: 24, sm: 12 } },
                                        [
                                          _c(
                                            "a-form-model-item",
                                            {
                                              key: "7",
                                              attrs: {
                                                label: _vm.$t("industry"),
                                                prop: "industry_id",
                                                required: "",
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  attrs: {
                                                    placeholder:
                                                      _vm.$t("selectInstry"),
                                                  },
                                                  model: {
                                                    value: _vm.form.industry_id,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "industry_id",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.industry_id",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.industryList,
                                                  function (item, index) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: index,
                                                        class: [_vm.lang],
                                                        attrs: { value: index },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(item) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.form.industry_id == 15
                                        ? _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "8",
                                                  attrs: {
                                                    label:
                                                      _vm.$t(
                                                        "Enteryourindustry"
                                                      ),
                                                    prop: "industry_desc",
                                                    required: "",
                                                  },
                                                },
                                                [
                                                  _c("a-input", {
                                                    attrs: {
                                                      placeholder: _vm.$t(
                                                        "Pleaseenteryourindustry"
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.industry_desc,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "industry_desc",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.industry_desc",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm.form.is_personal == 2 &&
                                          _vm.form.industry_id != 15
                                        ? _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "3",
                                                  attrs: {
                                                    label:
                                                      _vm.$t("Companyname"),
                                                    prop: "company_name",
                                                    required: "",
                                                  },
                                                },
                                                [
                                                  _c("a-input", {
                                                    attrs: {
                                                      placeholder:
                                                        _vm.$t(
                                                          "enterCompanyname"
                                                        ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.company_name,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "company_name",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.company_name",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.form.is_personal == 2 &&
                              _vm.form.industry_id == 15
                                ? [
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "a-col",
                                          { attrs: { xs: 24, sm: 12 } },
                                          [
                                            _c(
                                              "a-form-model-item",
                                              {
                                                key: "3",
                                                attrs: {
                                                  label: _vm.$t("Companyname"),
                                                  prop: "company_name",
                                                  required: "",
                                                },
                                              },
                                              [
                                                _c("a-input", {
                                                  attrs: {
                                                    placeholder:
                                                      _vm.$t(
                                                        "enterCompanyname"
                                                      ),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.company_name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "company_name",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.company_name",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-col",
                                          { attrs: { xs: 24, sm: 12 } },
                                          [
                                            _c(
                                              "a-form-model-item",
                                              {
                                                key: "4",
                                                attrs: {
                                                  label: _vm.$t("Companysize"),
                                                  prop: "size_id",
                                                  required: "",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-select",
                                                  {
                                                    attrs: {
                                                      placeholder:
                                                        _vm.$t(
                                                          "selectcompanysize"
                                                        ),
                                                    },
                                                    model: {
                                                      value: _vm.form.size_id,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "size_id",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.size_id",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.companyList,
                                                    function (item, index) {
                                                      return _c(
                                                        "a-select-option",
                                                        {
                                                          key: index,
                                                          class: [_vm.lang],
                                                          attrs: {
                                                            value: index,
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(item))]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "a-col",
                                          { attrs: { xs: 24, sm: 12 } },
                                          [
                                            _c(
                                              "a-form-model-item",
                                              {
                                                key: "9",
                                                attrs: {
                                                  label: _vm.$t("Positon"),
                                                  prop: "role_id",
                                                  required: "",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-select",
                                                  {
                                                    attrs: {
                                                      placeholder:
                                                        _vm.$t(
                                                          "selectposition"
                                                        ),
                                                    },
                                                    model: {
                                                      value: _vm.form.role_id,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "role_id",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.role_id",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.roleList,
                                                    function (item, index) {
                                                      return _c(
                                                        "a-select-option",
                                                        {
                                                          key: index,
                                                          class: [_vm.lang],
                                                          attrs: {
                                                            value: index,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(item) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.form.role_id == 6
                                          ? _c(
                                              "a-col",
                                              { attrs: { xs: 24, sm: 12 } },
                                              [
                                                _c(
                                                  "a-form-model-item",
                                                  {
                                                    key: "10",
                                                    attrs: {
                                                      label:
                                                        _vm.$t(
                                                          "Enteryourposition"
                                                        ),
                                                      prop: "custom_role",
                                                      required: "",
                                                    },
                                                  },
                                                  [
                                                    _c("a-input", {
                                                      attrs: {
                                                        placeholder:
                                                          _vm.$t(
                                                            "pleaseEnterPos"
                                                          ),
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.custom_role,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "custom_role",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.custom_role",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                              _vm.form.is_personal == 2 &&
                              _vm.form.industry_id != 15
                                ? [
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "a-col",
                                          { attrs: { xs: 24, sm: 12 } },
                                          [
                                            _c(
                                              "a-form-model-item",
                                              {
                                                key: "4",
                                                attrs: {
                                                  label: _vm.$t("Companysize"),
                                                  prop: "size_id",
                                                  required: "",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-select",
                                                  {
                                                    attrs: {
                                                      placeholder:
                                                        _vm.$t(
                                                          "selectcompanysize"
                                                        ),
                                                    },
                                                    model: {
                                                      value: _vm.form.size_id,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "size_id",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.size_id",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.companyList,
                                                    function (item, index) {
                                                      return _c(
                                                        "a-select-option",
                                                        {
                                                          key: index,
                                                          class: [_vm.lang],
                                                          attrs: {
                                                            value: index,
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(item))]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-col",
                                          { attrs: { xs: 24, sm: 12 } },
                                          [
                                            _c(
                                              "a-form-model-item",
                                              {
                                                key: "9",
                                                attrs: {
                                                  label: _vm.$t("Positon"),
                                                  prop: "role_id",
                                                  required: "",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-select",
                                                  {
                                                    attrs: {
                                                      placeholder:
                                                        _vm.$t(
                                                          "selectposition"
                                                        ),
                                                    },
                                                    model: {
                                                      value: _vm.form.role_id,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "role_id",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.role_id",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.roleList,
                                                    function (item, index) {
                                                      return _c(
                                                        "a-select-option",
                                                        {
                                                          key: index,
                                                          class: [_vm.lang],
                                                          attrs: {
                                                            value: index,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(item) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _vm.form.role_id == 6
                                          ? _c(
                                              "a-col",
                                              { attrs: { xs: 24, sm: 12 } },
                                              [
                                                _c(
                                                  "a-form-model-item",
                                                  {
                                                    key: "10",
                                                    attrs: {
                                                      label:
                                                        _vm.$t(
                                                          "Enteryourposition"
                                                        ),
                                                      prop: "custom_role",
                                                      required: "",
                                                    },
                                                  },
                                                  [
                                                    _c("a-input", {
                                                      attrs: {
                                                        placeholder:
                                                          _vm.$t(
                                                            "pleaseEnterPos"
                                                          ),
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.custom_role,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "custom_role",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.custom_role",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "billInfo" },
                            [
                              _c("div", { staticClass: "section-title2" }, [
                                _vm._v(_vm._s(_vm.$t("BillingAddress"))),
                              ]),
                              _c(
                                "a-row",
                                { attrs: { gutter: 16 } },
                                [
                                  _c(
                                    "a-col",
                                    { attrs: { xs: 24, sm: 12 } },
                                    [
                                      _c(
                                        "a-form-model-item",
                                        {
                                          key: "5",
                                          attrs: {
                                            label: _vm.$t("CountryRegion"),
                                            prop: "country_id",
                                            required: "",
                                          },
                                        },
                                        [
                                          _c(
                                            "a-select",
                                            {
                                              attrs: {
                                                placeholder: _vm.$t(
                                                  "SelectCountryRegion"
                                                ),
                                              },
                                              model: {
                                                value: _vm.form.country_id,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "country_id",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.country_id",
                                              },
                                            },
                                            _vm._l(
                                              _vm.locationList,
                                              function (item, index) {
                                                return _c(
                                                  "a-select-option",
                                                  {
                                                    key: index,
                                                    class: [_vm.lang],
                                                    attrs: { value: item.id },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.show_name) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-col",
                                    { attrs: { xs: 24, sm: 12 } },
                                    [
                                      _c(
                                        "a-form-model-item",
                                        {
                                          key: "101",
                                          attrs: {
                                            label: _vm.$t("State"),
                                            prop: "state",
                                            required: "",
                                          },
                                        },
                                        [
                                          _c("a-input", {
                                            attrs: {
                                              placeholder:
                                                _vm.$t("PleaseEnterState"),
                                            },
                                            model: {
                                              value: _vm.form.state,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.form, "state", $$v)
                                              },
                                              expression: "form.state",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-row",
                                { attrs: { gutter: 16 } },
                                [
                                  _c(
                                    "a-col",
                                    { attrs: { xs: 24, sm: 12 } },
                                    [
                                      _c(
                                        "a-form-model-item",
                                        {
                                          key: "102",
                                          attrs: {
                                            label: _vm.$t("StreetAddress"),
                                            prop: "street_address",
                                            required: "",
                                          },
                                        },
                                        [
                                          _c("a-input", {
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "PleaseEnterStreetAddress"
                                              ),
                                            },
                                            model: {
                                              value: _vm.form.street_address,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "street_address",
                                                  $$v
                                                )
                                              },
                                              expression: "form.street_address",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-col",
                                    { attrs: { xs: 24, sm: 12 } },
                                    [
                                      _c(
                                        "a-form-model-item",
                                        {
                                          key: "103",
                                          attrs: {
                                            label: _vm.$t("City"),
                                            prop: "city",
                                            required: "",
                                          },
                                        },
                                        [
                                          _c("a-input", {
                                            attrs: {
                                              placeholder:
                                                _vm.$t("PleaseEnterCity"),
                                            },
                                            model: {
                                              value: _vm.form.city,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.form, "city", $$v)
                                              },
                                              expression: "form.city",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-row",
                                { attrs: { gutter: 16 } },
                                [
                                  _c(
                                    "a-col",
                                    { attrs: { xs: 24, sm: 12 } },
                                    [
                                      _c(
                                        "a-form-model-item",
                                        {
                                          key: "102",
                                          attrs: {
                                            label: _vm.$t("ZipCode"),
                                            prop: "zip_code",
                                            required: "",
                                          },
                                        },
                                        [
                                          _c("a-input", {
                                            attrs: {
                                              placeholder:
                                                _vm.$t("PleaseEnterZipCode"),
                                            },
                                            model: {
                                              value: _vm.form.zip_code,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "zip_code",
                                                  $$v
                                                )
                                              },
                                              expression: "form.zip_code",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _c(
                        "a-form-model",
                        {
                          ref: "form",
                          staticClass: "billing-form",
                          attrs: {
                            model: _vm.form,
                            "label-col": { span: 24 },
                            "wrapper-col": { span: 24 },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "section-title" },
                            [
                              _c("span", [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("invoiceInformation"))
                                ),
                              ]),
                              _c(
                                "a-button",
                                {
                                  staticClass: "edit",
                                  on: { click: _vm.editInvoiceInfo },
                                },
                                [_vm._v(_vm._s(_vm.$t("EditInSetting")))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "billInfo",
                              staticStyle: {
                                border: "1px solid #52c41a",
                                background: "#f6ffed",
                                "-webkit-transition":
                                  "border 0.2s, background 0.2s",
                                transition: "border 0.2s, background 0.2s",
                              },
                            },
                            [
                              _vm.form.is_personal == 1
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "a-row",
                                        { attrs: { gutter: 16 } },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "1",
                                                  staticClass: "infoBold",
                                                  attrs: {
                                                    label: _vm.$t("Firstname"),
                                                    prop: "first_name",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.form.first_name
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "2",
                                                  staticClass: "infoBold",
                                                  attrs: {
                                                    label: _vm.$t("lastName"),
                                                    prop: "last_name",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.form.last_name
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-row",
                                        { attrs: { gutter: 16 } },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "6",
                                                  staticClass: "infoBold",
                                                  attrs: {
                                                    label: _vm.$t("Email"),
                                                    prop: "email",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.form.email) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "102",
                                                  staticClass: "infoBold",
                                                  attrs: {
                                                    label:
                                                      _vm.$t("StreetAddress"),
                                                    prop: "address",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.form.street_address
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-row",
                                        { attrs: { gutter: 16 } },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "5",
                                                  staticClass: "infoBold",
                                                  attrs: {
                                                    label:
                                                      _vm.$t("CountryRegion"),
                                                    prop: "country_id",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getCountryName(
                                                          _vm.form.country_id
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "101",
                                                  staticClass: "infoBold",
                                                  attrs: {
                                                    label: _vm.$t("State"),
                                                    prop: "state",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.form.state) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-row",
                                        { attrs: { gutter: 16 } },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "103",
                                                  staticClass: "infoBold",
                                                  attrs: {
                                                    label: _vm.$t("City"),
                                                    prop: "city",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.form.city) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "a-col",
                                                { attrs: { xs: 24, sm: 12 } },
                                                [
                                                  _c(
                                                    "a-form-model-item",
                                                    {
                                                      key: "102",
                                                      staticClass: "infoBold",
                                                      attrs: {
                                                        label:
                                                          _vm.$t("ZipCode"),
                                                        prop: "zip_code",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.form.zip_code
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.form.is_personal == 2
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "a-row",
                                        { attrs: { gutter: 16 } },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "3",
                                                  staticClass: "infoBold",
                                                  attrs: {
                                                    label:
                                                      _vm.$t("Companyname"),
                                                    prop: "company_name",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.form.company_name
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "6",
                                                  staticClass: "infoBold",
                                                  attrs: {
                                                    label: _vm.$t("Email"),
                                                    prop: "email",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.form.email) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-row",
                                        { attrs: { gutter: 16 } },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "102",
                                                  staticClass: "infoBold",
                                                  attrs: {
                                                    label:
                                                      _vm.$t("StreetAddress"),
                                                    prop: "street_address",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.form.street_address
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-row",
                                        { attrs: { gutter: 16 } },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "5",
                                                  staticClass: "infoBold",
                                                  attrs: {
                                                    label:
                                                      _vm.$t("CountryRegion"),
                                                    prop: "country_id",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getCountryName(
                                                          _vm.form.country_id
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "101",
                                                  staticClass: "infoBold",
                                                  attrs: {
                                                    label: _vm.$t("State"),
                                                    prop: "state",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.form.state) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-row",
                                        { attrs: { gutter: 16 } },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "a-form-model-item",
                                                {
                                                  key: "103",
                                                  staticClass: "infoBold",
                                                  attrs: {
                                                    label: _vm.$t("City"),
                                                    prop: "city",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.form.city) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "a-col",
                                                { attrs: { xs: 24, sm: 12 } },
                                                [
                                                  _c(
                                                    "a-form-model-item",
                                                    {
                                                      key: "102",
                                                      staticClass: "infoBold",
                                                      attrs: {
                                                        label:
                                                          _vm.$t("ZipCode"),
                                                        prop: "zip_code",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.form.zip_code
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _vm.$route.query.type != 4
                    ? _c(
                        "a-card",
                        {
                          staticClass: "order-detail",
                          staticStyle: { "margin-bottom": "16px" },
                        },
                        [
                          _c("div", { staticClass: "order-title" }, [
                            _vm._v(_vm._s(_vm.$t("Havediscount"))),
                          ]),
                          _c(
                            "div",
                            { staticClass: "discount-code" },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: _vm.$t("Entervalidcode"),
                                },
                                model: {
                                  value: _vm.discountCode,
                                  callback: function ($$v) {
                                    _vm.discountCode = $$v
                                  },
                                  expression: "discountCode",
                                },
                              }),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { padding: "0 10px" },
                                  attrs: { type: "primary" },
                                  on: { click: _vm.applyDiscount },
                                },
                                [_vm._v(_vm._s(_vm.$t("Confirm")))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "discount-desc",
                              style: {
                                color:
                                  _vm.codeInfo == "success" ? "green" : "red",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.codeInfo) + " ")]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "a-card",
                    { staticClass: "order-detail" },
                    [
                      _c(
                        "div",
                        { staticClass: "order-title", class: [_vm.lang] },
                        [_vm._v(" " + _vm._s(_vm.$t("Orderdetail")) + " ")]
                      ),
                      _c(
                        "div",
                        { staticClass: "order-row", class: [_vm.lang] },
                        [
                          _c("span", { staticClass: "text" }, [
                            _c("dl", { staticStyle: { margin: "0" } }, [
                              _c(
                                "dt",
                                { staticClass: "text", class: [_vm.lang] },
                                [
                                  _vm.info.type == 1
                                    ? [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("liteplan")) + " "
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm.info.type == 2
                                    ? [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("Proplan")) + " "
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm.info.type == 3
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("PrimePlan2")) +
                                            " "
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm.info.type == 4
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("FreeTrial")) +
                                            " "
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _c(
                                "dd",
                                {
                                  staticClass: "des",
                                  class: [_vm.lang],
                                  staticStyle: { margin: "0" },
                                },
                                [
                                  _vm.selectedAll
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("SalesRep")) +
                                            "& " +
                                            _vm._s(_vm.$t("Recruiter")) +
                                            " "
                                        ),
                                      ]
                                    : _vm.aiType == "1"
                                    ? [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("SalesRep")) + " "
                                        ),
                                      ]
                                    : _vm.aiType == "2"
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("Recruiter")) +
                                            " "
                                        ),
                                      ]
                                    : _vm.aiType == ""
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("PleaseselecteAI")) +
                                            " "
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]),
                          ]),
                          _c(
                            "span",
                            { staticClass: "price", class: [_vm.lang] },
                            [
                              _vm._v(
                                "$" +
                                  _vm._s(
                                    _vm.info.duration_type == 2
                                      ? _vm.planInfo.price
                                      : _vm.planInfo.original_price
                                  )
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm.info.type != 4
                        ? [
                            _vm.info.duration_type == 2 ||
                            _vm.info.duration_type == 3
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "order-row",
                                    class: [_vm.lang],
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "text",
                                        class: [_vm.lang],
                                      },
                                      [_vm._v(_vm._s(_vm.$t("Billingcycle")))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "link",
                                        class: [_vm.lang],
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.info.duration_type == 2
                                              ? _vm.$t("Monthlypayment")
                                              : _vm.$t("Annualpayment")
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.info.duration_type == 3
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "order-row",
                                    class: [_vm.lang],
                                  },
                                  [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v(_vm._s(_vm.$t("AnnualDiscount"))),
                                    ]),
                                    _c("span", { staticClass: "discount" }, [
                                      _vm._v(
                                        "- $" +
                                          _vm._s(
                                            (
                                              _vm.planInfo.original_price -
                                              _vm.planInfo.price
                                            ).toFixed(2)
                                          )
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _c("p", [_vm._v(_vm._s(_vm.$t("Tax")))]),
                      _vm.planInfo.discount_price
                        ? _c(
                            "div",
                            { staticClass: "order-row", class: [_vm.lang] },
                            [
                              _c("span", { staticClass: "text" }, [
                                _vm._v(_vm._s(_vm.$t("Extradiscount"))),
                              ]),
                              _c("span", { staticClass: "discount" }, [
                                _vm._v(
                                  "- $" + _vm._s(_vm.planInfo.discount_price)
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "order-row total", class: [_vm.lang] },
                        [
                          _c("span", { staticClass: "text" }, [
                            _vm._v(_vm._s(_vm.$t("Totalprice"))),
                          ]),
                          _c("span", { staticClass: "total-price" }, [
                            _vm._v("$" + _vm._s(_vm.planInfo.price)),
                          ]),
                        ]
                      ),
                      _c(
                        "a-button",
                        {
                          staticClass: "pay-btn",
                          class: [_vm.lang],
                          attrs: { type: "primary", block: "" },
                          on: { click: _vm.submitForm },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$route.query.type == 4
                                ? _vm.$t("Confirm")
                                : _vm.$t("Paynow")
                            )
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm.showModal
            ? _c("prime-upgrade-modal", {
                on: {
                  close: function ($event) {
                    _vm.showModal = false
                  },
                  upgrade: _vm.onUpgrade,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }